export default "/images/vendor/flag-icons/flags/4x3/gb-nir.svg?f0f1cf328d51869f9e70b6d1d92ca63b";